import VkPixel from '@/analytics/vk/VkPixel'

export default function init(app) {
  app.analytics.vkPixel = new VkPixel(app)
  app.analytics.vkPixel
    .install(app.$store.getters['settings/vkPixel'].id)
    .then(() => console.log('VK Pixel has been installed.'))
    .catch(err => console.error('Unable to install VK Pixel.', err))
}
